import { useDispatch } from 'react-redux';
import { changePayer } from '../../store/actions/payerListAction';
import { Payer } from '../models/payer.model';

const useSetDefaultPayer = (): any => {
  const dispatch = useDispatch();

  const setDefaultPayer = (): void => {
    const defaultPayer: Payer = {
      id: 0,
      name: '',
      isGovtScheme: false,
      isInsurer: true,
      uniqueIdentifier: '0',
      isDefaultPayer: false,
      key: '0',
      payerConfigurableProperties: {},
      blockedActions: {},
      shortName: '',
      isClaimSubmissionDisabled: false,
      networkActivationMessage: '',
    };
    dispatch(changePayer(defaultPayer));
  };
  return setDefaultPayer;
};
export default useSetDefaultPayer;
